/* import __COLOCATED_TEMPLATE__ from './first-time-ux-banner.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { get as getFromLocalStorage, set as setToLocalStorage } from '@square/dashboard-utilities/utils/persistable';
import { hasConsent, OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
const LOCAL_STORAGE_PREFIX = 'dashboard.first-time-ux.banner';
/**
 * A `market-banner` wrapper to display First-Time User Experience:
 * Checks local storage for the passed-in `token` to determine whether to
 * show the banner. The banner is shown until manually dismissed.
 * Nothing is shown if localStorage cannot be accessed to avoid unskippable
 * banners.
 *
 * Example usage:
 * <FirstTimeUx::FirstTimeUxBanner @token={{"uniqueTokenForComponent"}}>
 *   {{t "firstTimeUxBanner"}}
 * </FirstTimeUx::FirstTimeUxBanner>
 *
 * @class FirstTimeUXBanner
 * @extends {Component}
 * @param {String} [token] Required string that will be combined with a default
 * prefix and the user's merchant token to create the key used in local storage
 * that will store whether or not the banner has been previously dismissed.
 * @param {String} [className] Optional class name for the banner container.
 */
let FirstTimeUXBannerComponent = (_dec = computed('args.showWithoutCookies', 'hasCookieConsent', 'previouslyDismissed'), (_class = class FirstTimeUXBannerComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "hasCookieConsent", _descriptor2, this);
    _initializerDefineProperty(this, "previouslyDismissed", _descriptor3, this);
  }
  get token() {
    const {
      merchantToken
    } = this.userInfo;
    const argToken = this.args.token;
    return `${LOCAL_STORAGE_PREFIX}.${argToken}.${merchantToken}`;
  }
  get bannerDisabled() {
    if (!this.hasCookieConsent && this.args.showWithoutCookies) {
      return false;
    }
    return this.previouslyDismissed || !this.hasCookieConsent;
  }
  onBannerDismiss() {
    this.previouslyDismissed = true;
    setToLocalStorage(this.token, true, OneTrustConsent.FUNCTIONAL);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "hasCookieConsent", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return hasConsent(OneTrustConsent.FUNCTIONAL);
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "previouslyDismissed", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return Boolean(getFromLocalStorage(this.token));
  }
}), _applyDecoratedDescriptor(_class.prototype, "bannerDisabled", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "bannerDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBannerDismiss", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBannerDismiss"), _class.prototype)), _class));
export { FirstTimeUXBannerComponent as default };